import * as React from 'react';
import classNames from 'classnames';
import s from './ProductLineItem.scss';
import { Name } from './partials/Name/Name';
import { Price } from './partials/Price/Price';
import { TotalPrice } from './partials/TotalPrice/TotalPrice';
import { Options } from './partials/Options/Options';
import { ProductLineItemThumbnail } from './ProductLineItemThumbnail/ProductLineItemThumbnail';
import { Remove } from './partials/Remove/Remove';
import { OutOfStock } from './partials/OutOfStock/OutOfStock';
import { Quantity } from './partials/Quantity/Quantity';
import { ReadOnlyQuantity } from './partials/ReadOnlyQuantity/ReadOnlyQuantity';
import { Subscription } from './partials/Subscription/Subscription';
import { Link } from './partials/Link/Link';
export var ProductLineItemDataHook;
(function (ProductLineItemDataHook) {
    ProductLineItemDataHook["ComparePrice"] = "ProductLineItemDataHook.comparePrice";
    ProductLineItemDataHook["Name"] = "ProductLineItemDataHook.name";
    ProductLineItemDataHook["Options"] = "ProductLineItemDataHook.options";
    ProductLineItemDataHook["Price"] = "ProductLineItemDataHook.price";
    ProductLineItemDataHook["TotalPrice"] = "ProductLineItemDataHook.totalPrice";
    ProductLineItemDataHook["Remove"] = "ProductLineItemDataHook.remove";
    ProductLineItemDataHook["OutOfStockRoot"] = "ProductLineItemDataHook.outOfStockRoot";
    ProductLineItemDataHook["OutOfStockError"] = "ProductLineItemDataHook.outOfStockError";
    ProductLineItemDataHook["Quantity"] = "ProductLineItemDataHook.quantity";
    ProductLineItemDataHook["QuantityErrorTooltip"] = "ProductLineItemDataHook.quantityErrorTooltip";
    ProductLineItemDataHook["ReadOnlyQuantity"] = "ProductLineItemDataHook.readOnlyQuantity";
    ProductLineItemDataHook["Subscription"] = "ProductLineItemDataHook.Subscription";
    ProductLineItemDataHook["LinkText"] = "ProductLineItemDataHook.LinkText";
    ProductLineItemDataHook["Link"] = "ProductLineItemDataHook.Link";
})(ProductLineItemDataHook || (ProductLineItemDataHook = {}));
export var ProductLineItem = function (props) {
    var children = props.children, _a = props.withDivider, withDivider = _a === void 0 ? true : _a;
    var NameToCmpMap = children.reduce(function (acc, child) {
        var _a;
        if ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) {
            acc[child.type.displayName] = child;
        }
        return acc;
    }, {});
    var image = NameToCmpMap['ProductLineItem.Image'];
    var name = NameToCmpMap['ProductLineItem.Name'];
    var price = NameToCmpMap['ProductLineItem.Price'];
    var totalPrice = NameToCmpMap['ProductLineItem.TotalPrice'];
    var subscription = NameToCmpMap['ProductLineItem.Subscription'];
    var options = NameToCmpMap['ProductLineItem.Options'];
    var remove = NameToCmpMap['ProductLineItem.Remove'];
    var outOfStock = NameToCmpMap['ProductLineItem.OutOfStock'];
    var quantity = NameToCmpMap['ProductLineItem.Quantity'];
    var readOnlyQuantity = NameToCmpMap['ProductLineItem.ReadOnlyQuantity'];
    var link = NameToCmpMap['ProductLineItem.Link'];
    return (React.createElement("div", { className: classNames(s.itemWrapper, withDivider ? s.withDivider : null) },
        React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.containerItem }, image),
            React.createElement("div", { className: classNames(s.containerItem, s.detailsContainer) },
                React.createElement("div", { className: s.details },
                    name,
                    price,
                    subscription,
                    options,
                    link)),
            React.createElement("div", { className: classNames(s.containerItem, s.quantityContainer) },
                quantity,
                readOnlyQuantity),
            React.createElement("div", { className: classNames(s.containerItem, s.totalContainer) }, totalPrice),
            React.createElement("div", { className: classNames(s.containerItem, s.removeButtonContainer) }, remove)),
        outOfStock));
};
ProductLineItem.displayName = 'ProductLineItem';
ProductLineItem.Image = ProductLineItemThumbnail;
ProductLineItem.Name = Name;
ProductLineItem.Price = Price;
ProductLineItem.TotalPrice = TotalPrice;
ProductLineItem.Options = Options;
ProductLineItem.Remove = Remove;
ProductLineItem.OutOfStock = OutOfStock;
ProductLineItem.Quantity = Quantity;
ProductLineItem.ReadOnlyQuantity = ReadOnlyQuantity;
ProductLineItem.Subscription = Subscription;
ProductLineItem.Link = Link;
//# sourceMappingURL=ProductLineItem.js.map